module.exports = __webpack_public_path__ + "static/img/portrait_fr.1ed270f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/portrait_fr.png
// module id = qxbt
// module chunks = 0